import gql from 'graphql-tag'

export default gql`
query AllUnreads($userId: ID!) {
  allUnreads(
    userId: $userId
  )
}`



// WEBPACK FOOTER //
// ./src/graphql/chat/queries/all-unreads.query.js